import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'
import store from 'src/store'
import { Provider } from 'react-redux'
import { AxiosInterceptor } from 'src/lib/axios'
import { ConfirmDialog } from 'src/components/system_wide/confirm_dialog'
import RisikoIdeaRoute from 'src/components/ri_route'
import 'src/i18n'
import 'src/index.scss'
import './styles/globals.css'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <AxiosInterceptor>
        <RisikoIdeaRoute />
      </AxiosInterceptor>
      <ConfirmDialog />
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
